// Детермінований генератор: для того самого seed завжди та сама послідовність.
// Використовується для «згенерованих» даних користувача (телефон, CVV,
// термін дії картки), які мають бути стабільними між запусками.
export default function seededRandom(seed) {
  let h = 0;
  const str = String(seed);
  for (let i = 0; i < str.length; i++) {
    h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  }
  return function next() {
    h = Math.imul(h ^ (h >>> 15), h | 1);
    h ^= h + Math.imul(h ^ (h >>> 7), h | 61);
    return ((h ^ (h >>> 14)) >>> 0) / 4294967296;
  };
}
